import { render, staticRenderFns } from "./vue-datepicker.vue?vue&type=template&id=5a5c77fa&scoped=true"
import script from "./vue-datepicker.vue?vue&type=script&lang=js"
export * from "./vue-datepicker.vue?vue&type=script&lang=js"
import style0 from "./vue-datepicker.vue?vue&type=style&index=0&id=5a5c77fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c77fa",
  null
  
)

export default component.exports